import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PATH_DASHBOARD } from '../paths';

export function PublicRouter({ children }) {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return children;
}

PublicRouter.propTypes = {
  children: PropTypes.node,
};
